export const categories = [
  {
    id: "sofas",
    name: "Sofas",
    slug: "sofas",
    description: "Sink into luxury",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&q=80",
  },
  {
    id: "wardrobes",
    name: "Wardrobes",
    slug: "wardrobes",
    description: "Elegance organized",
    image: "https://images.unsplash.com/photo-1558997519-83ea9252edf8?w=600&q=80",
  },
  {
    id: "dressing-tables",
    name: "Dressing Tables",
    slug: "dressing-tables",
    description: "Morning rituals, elevated",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=600&q=80",
  },
  {
    id: "beds",
    name: "Beds",
    slug: "beds",
    description: "Restful by design",
    image: "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=600&q=80",
  },
  {
    id: "study-tables",
    name: "Study Tables",
    slug: "study-tables",
    description: "Work with intention",
    image: "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?w=600&q=80",
  },
  {
    id: "kids-furniture",
    name: "Kids Furniture",
    slug: "kids-furniture",
    description: "Playful & safe",
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=600&q=80",
  },
];

export const designs = [
  {
    id: 1,
    slug: "aria-cloud-sofa",
    name: "Aria Cloud Sofa",
    category: "sofas",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=900&q=80",
      "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=900&q=80",
      "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?w=900&q=80",
    ],
    description:
      "A low, generous three-seater designed for evenings that stretch on. Premium leather upholstery over a solid walnut frame — proportions tuned for Nepali living rooms. Reference design for our consultation work; final dimensions, leather grade, and frame timber are tailored to your space.",
    material: "Premium leather, solid walnut frame",
    dimensions: "Reference: W 220cm × D 95cm × H 80cm",
    finishes: ["Cream Beige", "Charcoal Gray", "Caramel Brown"],
    tags: ["minimalist", "leather", "living room"],
    featured: true,
  },
  {
    id: 2,
    slug: "serene-platform-bed",
    name: "Serene Platform Bed",
    category: "beds",
    image: "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=900&q=80",
      "https://images.unsplash.com/photo-1588046130717-0eb0c9a3ba15?w=900&q=80",
      "https://images.unsplash.com/photo-1560448204-444f0e5b5e5b?w=900&q=80",
    ],
    description:
      "A low-profile teak platform with an upholstered headboard that anchors the room without overwhelming it. Built for couples who treat the bedroom as a retreat. Headboard fabric, mattress size, and storage drawers are all customised during design.",
    material: "Solid teak, fabric-upholstered headboard",
    dimensions: "Reference: W 180cm × L 210cm × H 90cm (King)",
    finishes: ["Warm White", "Slate Gray", "Deep Walnut"],
    tags: ["teak", "bedroom", "low-profile"],
    featured: true,
  },
  {
    id: 3,
    slug: "atelier-wardrobe",
    name: "Atelier Wardrobe",
    category: "wardrobes",
    image: "https://images.unsplash.com/photo-1558997519-83ea9252edf8?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1558997519-83ea9252edf8?w=900&q=80",
    ],
    description:
      "A modular wardrobe system that mixes open display shelving with concealed flush-panel storage. Built around how you actually dress — hanging space, drawer counts, and accessory inserts are designed in consultation, then fabricated to fit your wall exactly.",
    material: "American oak veneer, brass hardware",
    dimensions: "Reference: W 200cm × D 60cm × H 220cm (modular)",
    finishes: ["Natural Oak", "Matte White", "Graphite"],
    tags: ["modular", "joinery", "bedroom"],
    featured: true,
  },
  {
    id: 4,
    slug: "lumiere-dressing-table",
    name: "Lumière Dressing Table",
    category: "dressing-tables",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=900&q=80",
    ],
    description:
      "A hand-lacquered dressing table with a backlit Hollywood mirror and brass pulls. The mirror size, lacquer colour, and drawer layout are all tuned during the design phase to match the rest of the bedroom.",
    material: "MDF with hand-lacquered finish, brass hardware, LED mirror",
    dimensions: "Reference: W 120cm × D 45cm × H 145cm",
    finishes: ["Soft White", "Dusty Rose", "Matte Black"],
    tags: ["lacquered", "bedroom", "vanity"],
    featured: true,
  },
  {
    id: 5,
    slug: "scholar-pro-desk",
    name: "Scholar Pro Desk",
    category: "study-tables",
    image: "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?w=900&q=80",
    ],
    description:
      "A minimalist work surface with integrated cable management and a slim steel frame. Built in solid sheesham, sized to your room and your monitor setup. A favourite for home offices and serious students.",
    material: "Solid sheesham, matte steel legs",
    dimensions: "Reference: W 150cm × D 70cm × H 76cm",
    finishes: ["Walnut", "Light Ash", "Ebony"],
    tags: ["home office", "minimalist"],
    featured: false,
  },
  {
    id: 6,
    slug: "dreamland-bunk-bed",
    name: "Dreamland Bunk Bed",
    category: "kids-furniture",
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=900&q=80",
    ],
    description:
      "A safety-engineered bunk in non-toxic painted pine — integrated ladder, full guardrails, and storage steps. We size it to your kids' room and personalise the colour palette during design.",
    material: "Non-toxic painted solid pine, safety-tested hardware",
    dimensions: "Reference: W 100cm × L 200cm × H 160cm",
    finishes: ["Soft White", "Sky Blue", "Sage Green"],
    tags: ["kids", "safety", "bunk"],
    featured: false,
  },
  {
    id: 7,
    slug: "velvet-haven-sectional",
    name: "Velvet Haven Sectional",
    category: "sofas",
    image: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=900&q=80",
    ],
    description:
      "A modular velvet sectional with feather-down cushions over a solid beech frame. Configurable from a tight three-seater to a sprawling L-shape — the layout is decided in design, then hand-stitched at the factory.",
    material: "Belgian velvet, solid beech frame, feather-down cushions",
    dimensions: "Reference: 280cm – 420cm (configurable)",
    finishes: ["Midnight Navy", "Forest Green", "Dusty Mauve"],
    tags: ["velvet", "modular", "living room"],
    featured: false,
  },
  {
    id: 8,
    slug: "nordic-king-bed",
    name: "Nordic King Bed",
    category: "beds",
    image: "https://images.unsplash.com/photo-1588046130717-0eb0c9a3ba15?w=700&q=80",
    images: [
      "https://images.unsplash.com/photo-1588046130717-0eb0c9a3ba15?w=900&q=80",
    ],
    description:
      "Scandinavian-leaning lines in solid oak with a linen-upholstered headboard. A quiet, anchored presence for a master bedroom. Storage drawers and headboard fabric are picked during the design phase.",
    material: "Solid oak, linen headboard",
    dimensions: "Reference: W 190cm × L 210cm × H 100cm",
    finishes: ["Natural Oak", "Whitewash", "Smoked Oak"],
    tags: ["oak", "scandinavian", "bedroom"],
    featured: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Kathmandu, Nepal",
    role: "Interior Designer",
    text: "Ananda is the person other interior designers in Kathmandu call when a project needs a piece nobody else can deliver. His factory network and his eye for proportion are unmatched.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
  },
  {
    id: 2,
    name: "Rajesh Khatiwada",
    location: "Pokhara, Nepal",
    role: "Architect",
    text: "We furnished three luxury homes through Ananda. He listened, designed, then built — every piece arrived sized to the room and finished exactly as briefed. End-to-end accountability you don't get from a showroom.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80",
  },
  {
    id: 3,
    name: "Sushila Tamang",
    location: "Bhaktapur, Nepal",
    role: "Homeowner",
    text: "Started with a free consultation, ended with a fully furnished home. Ananda walked us through every material choice. Six months later, not a single piece feels generic — it all feels like ours.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80",
  },
  {
    id: 4,
    name: "Binod Thapa",
    location: "Lalitpur, Nepal",
    role: "Business Owner",
    text: "Ananda designed and built our entire office reception. The brief was 'professional but warm' — what arrived was exactly that, in our exact dimensions. Clients comment on it weekly.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80",
  },
];

export const homeFaqs = [
  {
    q: "How do you charge — is there a fee for the consultation?",
    a: "The first consultation is free. We discuss your space, taste, and budget. After that, design fees roll into the build cost — you only pay once the design is approved and fabrication begins.",
  },
  {
    q: "How long does a project take?",
    a: "A single piece is typically 3–6 weeks from approved design. Full-room or full-home projects take 8–14 weeks depending on scope. Timelines are confirmed before fabrication starts.",
  },
  {
    q: "Can you build a custom piece from a photo or sketch?",
    a: "Yes — that's the core of how we work. Send a reference photo, sketch, or a written description, and we'll design and fabricate it to your dimensions, materials, and finish.",
  },
  {
    q: "Do you deliver outside Kathmandu Valley?",
    a: "Yes. Free delivery and installation across Kathmandu Valley; Pokhara, Chitwan, and most major cities are covered for a small logistics fee. Long-haul deliveries are quoted in design.",
  },
  {
    q: "Why is there no showroom?",
    a: "Showroom rent and inventory costs are passed to customers. Working directly with Ananda means factory-direct pricing and zero overhead markup — every rupee goes into the piece, not the lease.",
  },
  {
    q: "What if I don't like the design after the consultation?",
    a: "No obligation. The consultation is free and the design phase is optional. You're only committed once you approve the design and a fabrication deposit is placed.",
  },
];
